<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  watch: {
    $route(to, from) {
      sessionStorage.setItem("active", to.path.split("/")[1]);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/reset.scss";
@import "@/assets/css/transition.scss";

.message-zindex {
  z-index: 10000 !important;
}
</style>
